import React, { useState } from 'react';
import s from './s.module.less';

interface Testimonial {
    id: number;
    name: string;
    date: string;
    text: string;
    avatar: string;
}

interface TestimonialSectionProps {
    testimonials: Testimonial[];
}

const TestimonialSection: React.FC<TestimonialSectionProps> = ({ testimonials }) => {
    const [activeIndex, setActiveIndex] = useState(2); // 默认选择中间的testimonial (index 2)

    const handleAvatarClick = (index: number) => {
        setActiveIndex(index);
    };

    const activeTestimonial = testimonials[activeIndex];

    return (
        <div className={s.testimonialsSection}>
            <h2>What providers say about Klarity</h2>
            {/* 桌面端布局 */}
            <div className={s.desktopLayout}>
                <div className={s.testimonialContainer}>
                    <div className={s.avatarsRow}>
                        {testimonials.map((testimonial, index) => (
                            <div
                                key={testimonial.id}
                                className={`${s.avatarWrapper} ${index === activeIndex ? s.active : ''}`}
                                onClick={() => handleAvatarClick(index)}
                            >
                                {index === activeIndex ? (
                                    // 当前选中的头像，显示较大尺寸和信息
                                    <div className={s.testimonialAvatarLarge}>
                                        <div className={s.largeAvatar}>
                                            <img src={testimonial.avatar} className={s.avatarPlaceholder} />
                                        </div>
                                        <div className={s.testimonialInfo}>
                                            <span className={s.testimonialName}>{testimonial.name}</span>
                                            <span className={s.testimonialDate}>{testimonial.date}</span>
                                        </div>
                                    </div>
                                ) : (
                                    // 普通头像
                                    <div className={s.testimonialAvatar}>
                                        <img src={testimonial.avatar} className={s.avatarPlaceholder} />
                                    </div>
                                )}
                                {/* 每个provider都有自己的bubble arrow */}
                                <div className={`${s.bubbleArrow} ${index === activeIndex ? s.visible : ''}`} />
                            </div>
                        ))}
                    </div>
                    <div className={s.testimonialBubble}>
                        <div className={s.testimonialText}>
                            &quot;{activeTestimonial.text}&quot;
                        </div>
                    </div>
                </div>
            </div>

            {/* 移动端布局 */}
            <div className={s.mobileLayout}>
                <div className={s.mobileCardsContainer}>
                    {testimonials.map((testimonial) => (
                        <div key={testimonial.id} className={s.mobileTestimonialCard}>
                            {/* Provider信息在上方 */}
                            <div className={s.mobileProviderInfo}>
                                <div className={s.mobileAvatar}>
                                    <img src={testimonial.avatar} className={s.avatarPlaceholder} />
                                </div>
                                <div className={s.mobileProviderDetails}>
                                    <span className={s.mobileProviderName}>{testimonial.name}</span>
                                    <span className={s.mobileProviderDate}>{testimonial.date}</span>
                                </div>
                            </div>
                            {/* Testimonial内容在下方 */}
                            <div className={s.mobileCardContent}>
                                <div className={s.mobileCardArrow} />
                                <div className={s.mobileCardText}>
                                    &quot;{testimonial.text}&quot;
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default TestimonialSection;
